module.exports = __webpack_public_path__ + "static/img/latest-activity-list-update.cc598e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/latest-activity-list-update.svg
// module id = 455
// module chunks = 0